import {
  initialFormData,
  ReceivingReportRecord,
  RRMovement,
} from '../types/ReceivingReport';
import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';
import { IssueMovement } from '../types/MaterialRequest';

type ReceivingReportState = {
  data: ReceivingReportRecord | null;
  setData: (data: ReceivingReportRecord | null) => void;
  formData: ReceivingReportRecord;
  setFormData: (data: ReceivingReportRecord) => void;
  movement: RRMovement | null;
  setMovement: (data: RRMovement) => void;
  addMovement: (data: RRMovement) => void;
  editMovement: (id: string, data: RRMovement) => void;
  removeMovement: (id: string) => void;
  resetForm: () => void;
  receivedMovement: IssueMovement | null;
  setReceivedMovement: (receivedMovement: IssueMovement) => void;
};

export const useReceivingReportStore = create<ReceivingReportState>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  formData: initialFormData,
  setFormData: (formData) => set({ formData }),
  movement: null,
  setMovement: (movement) => set({ movement }),
  addMovement: (data: RRMovement) => {
    const newData = { ...data, uuid: uuidv4() };
    set((state) => ({
      formData: {
        ...state.formData,
        movements: [...state.formData.movements, newData],
      },
    }));
  },
  editMovement: (uuid, newData) => {
    set((state) => ({
      formData: {
        ...state.formData,
        movements: state.formData.movements.map((line) =>
          line.uuid === uuid ? { ...line, ...newData } : line,
        ),
      },
    }));
  },
  removeMovement: (uuid) => {
    set((state) => ({
      formData: {
        ...state.formData,
        movements: state.formData.movements.filter(
          (line) => line.uuid !== uuid,
        ),
      },
    }));
  },
  resetForm: () => set({ formData: initialFormData }),
  receivedMovement: null,
  setReceivedMovement: (receivedMovement) => set({ receivedMovement }),
}));
